import { Result } from "appworks/model/gameplay/records/results/result";

// Used to add back the total win during recovery
export class SlingoRecoveryWinResult extends Result {
    public resultType: string = "SlingoRecoveryWinResult";
}